import { create } from 'zustand';

export interface ModalState<T> {
  isOpen: boolean;
  meta?: T;
}

interface ActionSheetStore<T = unknown> {
  map: Map<string, ModalState<T>>;
  setModal: (name: string) => (state: ModalState<T>) => void;
  current?: string;
  setCurrent: (name?: string) => void;
}

export const useModalStore = create<ActionSheetStore>((set) => ({
  map: new Map(),
  setModal: (name) => (state) => {
    set((prev) => {
      const prevState = prev.map.get(name);

      return {
        map: new Map(prev.map).set(name, { ...prevState, ...state }),
        current: name,
      };
    });
  },
  current: undefined,
  setCurrent: (name) => {
    set({ current: name });
  },
}));
